import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=1f8fb9d2&scoped=true&"
import script from "./Audits.vue?vue&type=script&lang=js&"
export * from "./Audits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8fb9d2",
  null
  
)

export default component.exports